module.exports = __webpack_public_path__ + "static/img/home-top-bg.a003e91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grade/home-top-bg.png
// module id = 9FJH
// module chunks = 1